// BEUS-11496 M3: api-hub `/v2/heatmap/*` 호출. 켜는 방법은 src/libs/heatmap-v2/flag.js.
import httpClientHub from '@/libs/http-client-hub'

export class HeatmapV2Error extends Error {
  constructor (status, code, message) {
    super(message || code || 'HEATMAP_V2_ERROR')
    this.status = status
    this.code = code
  }
}

// api-hub는 성공 응답을 { data: { result } } 또는 { result }로 준다(공통 응답 포장 여부에 따라).
// 4xx는 http-client-hub 설정상 reject되지 않으므로 여기서 오류로 바꾼다. 503(공개 범위 밖·준비 안 됨)은 reject로 온다.
export function postV2 (path, body) {
  return httpClientHub.post(`/v2/heatmap/${path}`, body).then(response => {
    const payload = response.data || {}
    if (response.status >= 400) {
      const err = payload.error || (payload.data && payload.data.error) || {}
      throw new HeatmapV2Error(response.status, err.code, err.message)
    }
    const result = payload.result || (payload.data && payload.data.result)
    if (!result) throw new HeatmapV2Error(response.status, 'HEATMAP_V2_EMPTY', 'No result in response')
    return result
  })
}

export const getScrollV2 = body => postV2('scroll', body)
// M3 기존 화면 호환: 기존 /es/get_scroll 응답의 fold(Scroll Statistics 패널), 모양도 기존 그대로
export const getScrollFoldV2 = body => postV2('scroll/fold', body)
export const getSummaryV2 = body => postV2('summary', body)
export const getPositionsV2 = body => postV2('positions', body)
export const getElementsV2 = body => postV2('elements', body)
// M3 기존 화면 호환(DOM 목록 부분, 응답 모양은 기존 /es/get_heatmap_by_event 그대로)
export const getElementsScreenV2 = body => postV2('elements/screen', body)
// 지금 공개 범위(coverageStart·watermarkAt·cutoverAt). 오늘 날짜 조회 끝 시각 자르기용(src/libs/heatmap-v2/watermark.js)
export const getStatusV2 = body => postV2('status', body)
